import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { BreadCrumb, Loader, Paragraph, Title } from '@components/atoms'
import SearchInput from '@components/atoms/SearchInput'
import { Check20Regular } from '@fluentui/react-icons'
import { ResultSimulateHistoric } from '@models/simulated.model'
import { simulatedAPI } from '@services/SimulatedAPI'
import moment from 'moment'

import { SimulateStyles } from '../style'
import { stylesSimulatedHistoric } from './style'

const { container, title } = SimulateStyles
const {
	HistoricItem,
	containerHisoricalItems,
	containerInput,
	contentStatus,
	contentStatus2,
} = stylesSimulatedHistoric

export type SelectWeek = {
	selectWeek: { label: string; value: string }
}

export const SimulateHistoric = () => {
	const [historical, setHistorical] = useState<ResultSimulateHistoric>([])
	const [search, setSearch] = useState<string>('')

	const [getSimulateHistoric, { data, isSuccess, isLoading }] =
		simulatedAPI.useGetSimulateHistoricMutation()

	const { id } = useParams()

	const filteredHistorical =
		historical &&
		historical.filter((option) =>
			option.mockExam.name.toLowerCase().includes(search.toLowerCase())
		)

	useEffect(() => {
		getSimulateHistoric(String(id))
	}, [getSimulateHistoric, id])

	useEffect(() => {
		if (isSuccess && data) {
			setHistorical(
				data.map((item, index) => ({
					...item,
					mockExam: {
						...item.mockExam,
						name: `${item.mockExam.name} - Resolução ${data.length - index}`,
					},
				}))
			)
		}
	}, [data, isSuccess])

	return (
		<div className={container()}>
			<div>
				<BreadCrumb
					buttonReturn
					locations={[
						{ name: 'Simulados', link: '/simulados' },
						{
							name: data && data[0] ? data[0].mockExam.name : '',
							link:
								data && data[0]
									? `/simulados/${data[0].mockExam.categoryId}`
									: '',
						},
						{ name: 'Prova', link: `/simulados/prova/${id}` },
						{ name: 'Histórico', link: '' },
					]}
				/>

				<div className={title()}>
					<Title variant='h1' color='$neutral160'>
						Histórico
					</Title>
				</div>
			</div>

			<div className={containerInput()}>
				<SearchInput
					placeholder='Busque pelo nome'
					maxLength={30}
					css={{ maxWidth: '100%', '@md': { maxWidth: '287px' } }}
					onChange={(e) => setSearch(e.target.value)}
					value={search}
				/>
			</div>

			<div>
				{isLoading ? (
					<Loader />
				) : (
					<div className={containerHisoricalItems()}>
						{filteredHistorical &&
							filteredHistorical.map((card, index) => (
								<Link
									to={`/simulados/resultado/?mookID=${card.mock_id}&resolutionId=${card.id}`}
									key={index}
								>
									<HistoricItem>
										<Title variant='h6' color='$neutral100'>
											{card.mockExam.name}
										</Title>
										<div style={{ width: '100%' }}>
											<div className={contentStatus()}>
												{card.conclusion_time && (
													<Paragraph
														paragraphType='p2'
														css={{ color: '$neutral100' }}
													>
														Tempo: {card.conclusion_time}
													</Paragraph>
												)}
												<Paragraph
													paragraphType='p2'
													css={{ color: '$neutral100' }}
												>
													Data: {moment(card.created_at).format('DD/MM/YYYY')}
												</Paragraph>
											</div>
											<div className={contentStatus2()}>
												<Paragraph
													paragraphType='p3'
													css={{
														color: '$neutral100',
														display: 'flex',
														gap: '8px',
													}}
												>
													<Check20Regular />
													Nota
												</Paragraph>

												<Title variant='h6' color='$blue20'>
													{`${card.points || 0}`}
												</Title>
											</div>
										</div>
									</HistoricItem>
								</Link>
							))}
					</div>
				)}
			</div>
		</div>
	)
}
